import styled from 'styled-components';
import { FlexContainer } from './FlexContainer';
import { CustomLabel } from './CustomLabel';

interface IStyleProps {
  height?: string;
  margin?: string;
}

export const PlaceholderWrapper = styled.div<IStyleProps>`
  min-height: 150px;
  width: 100%;
  /* height: calc(100vh - ${props => props.height || '417px'}); */

  height: ${props => props.height || '100%'};
  > ${FlexContainer}.plh-main-section {
    /* height: 100%; */ // create issue in case of opened item plh
    min-height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 1px solid #ddd;
    border-radius: 10px;
    .plh-main-icon {
      height: 100px;
      width: 100px;
    }
    .plh-icon-margin {
      margin-top: 60px;
    }
    ${CustomLabel} {
      &.plh-label {
        font-size: 30px;
        margin: ${props => props.margin || '11px auto 0px'};
        text-align: center;
        line-height: normal;
        color: #aaa;
        font-weight: 600;
      }
      &.plh-description {
        color: #aaa;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  ${FlexContainer}.plh-sub-section {
    width: 100%;
    align-items: flex-start;
    justify-content: center;
    gap: 60px;
    margin: 15% auto 3%;
    width: 800px;
    height: 100%;
    > div {
      text-align: center;
      transition: all 0.3s;
      position: relative;
      img {
        height: 62px;
        width: 62px;
      }
      ${CustomLabel} {
        font-size: 18px;
        font-weight: 600;
        color: #273e52;
        display: block;
        margin-top: 10px;
        cursor: pointer;
      }
    }
    &.bubble-height {
      /* height: 350px !important; */
      margin: 15% auto 3%;
    }
  }
  .plh-btn {
    font-size: 22px;
    line-height: 26px;
    height: auto;
    margin-top: 30px;
    padding: 10px 25px;
    color: #fff;
    background-color: #556bb8;
    &:hover {
      color: #556bb8;
      background: #fff;
    }
  }
  &.basic-plh {
    &.basic-plh-height {
      height: calc(100vh - 250px);
      .plh-label {
        font-size: 26px !important;
        margin: 30px 60px 15px !important;
      }
    }
    .plh-main-section {
      border: none;
    }
  }
`;

export const BubbleWrapper = styled.div`
  width: 800px;
  height: auto;
  min-height: 50px;
  position: absolute;
  /* top: 0; */
  left: 0;
  /* transform: translate(-86px, 120px); */
  background-color: #fff;
  border-radius: 4px;
  text-align: left;
  overflow-y: visible;
  border: 1px solid #d9d9d9;
  padding: 30px;
  font-size: 15px;
  font-weight: 400;
  min-width: 200px;
  /* opacity: 0.6; */
  /* for bubble wrapper to be at top */
  top: unset;
  opacity: 1;
  bottom: 0;
  transform: translate(-86px, -120px);

  &::before {
    position: absolute;
    /* top: 0px; */
    left: 0;
    right: unset;
    border-right: 25px solid transparent;
    /* border-bottom: 20px solid #d9d9d9; */
    border-left: 25px solid transparent;
    /* transform: translate(98px, -20px); */
    content: '';
    /* for bubble wrapper to be at top */
    top: unset;
    bottom: 0;
    border-top: 20px solid #d9d9d9;
    transform: translate(98px, 20px);
  }
  &::after {
    position: absolute;
    /* top: 0px; */
    left: 0;
    right: unset;
    border-right: 25px solid transparent;
    /* border-bottom: 20px solid #fff; */
    border-left: 25px solid transparent;
    content: '';
    transform: translate(98px, -18px);
    /* for bubble wrapper to be at top */
    top: unset;
    bottom: 0;
    border-top: 20px solid #fff;
    transform: translate(98px, 18px);
  }
  /* Custom Classes */
  &.service-bubble {
    transform: translate(-216px, -120px);
    &::before {
      transform: translate(220px, 20px);
    }
    &::after {
      transform: translate(220px, 18px);
    }
  }
  &.membership-bubble {
    transform: translate(-42%, -120px);
    &::before {
      transform: translate(365px, 20px);
    }
    &::after {
      transform: translate(365px, 18px);
    }
  }
  &.donation-bubble {
    transform: translate(-63%, -120px);
    &::before {
      left: unset;
      right: 0;
      transform: translate(-228px, 20px);
    }
    &::after {
      left: unset;
      right: 0;
      transform: translate(-228px, 18px);
    }
  }
  &.bundle-bubble {
    transform: translate(-81%, -120px);
    &::before {
      left: unset;
      right: 0;
      transform: translate(-96px, 20px);
    }
    &::after {
      left: unset;
      right: 0;
      transform: translate(-96px, 18px);
    }
  }
`;
